import React from "react";
import { ArrowRight } from "lucide-react";

const HERO_SLIDES = [1, 2, 3, 4, 5, 6];

const heroSlide =
  HERO_SLIDES[Math.floor(Math.random() * HERO_SLIDES.length)];

const Hero = () => {
  return (
    <section className="cvx-hero relative overflow-hidden">
      <picture
        className={`cvx-hero-image cvx-hero-image-${heroSlide}`}
        aria-hidden="true"
      >
        <source
          media="(max-width: 640px)"
          srcSet={`/images/hero/mobile/slide${heroSlide}-opt.jpg`}
        />
        <source
          media="(max-width: 1023px)"
          srcSet={`/images/hero/tablet/slide${heroSlide}-opt.jpg`}
        />
        <img
          src={`/images/hero/slide${heroSlide}-opt.jpg`}
          alt=""
          width="2000"
          height="1333"
          loading="eager"
          fetchPriority="high"
        />
      </picture>

      <div className="cvx-hero-shade" aria-hidden="true" />

      <div className="container mx-auto px-5 sm:px-8 relative z-10">
        <div className="cvx-hero-content">
          <div className="max-w-2xl">
            <div className="cvx-eyebrow mb-6">
              <span className="cvx-status-dot" />
              Veterinary practice management software
            </div>

            <h1 className="cvx-display text-white mb-6">
              Less screen time.
              <br />
              <span className="cvx-display-accent">More pet time.</span>
            </h1>

            <p className="text-lg sm:text-xl leading-relaxed text-white max-w-xl mb-9">
              Manage appointments, patient records, clinical notes, invoices and
              inventory in CloudVetX. Keep clients informed with WhatsApp
              reminders and give your team a clearer view of the day.
            </p>

            <div className="flex flex-col sm:flex-row gap-4">
              <a href="/#contact" className="cvx-hero-primary">
                Ask about the founders pilot
                <ArrowRight size={19} aria-hidden="true" />
              </a>

              <a href="/#features" className="cvx-hero-secondary">
                See the features
              </a>
            </div>

            <p className="text-sm text-white/85 mt-7">
              Inviting a small group of independent clinics in the Gulf.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;